export const SET_NEW_STATUS_ASSIGNED = 'SET_NEW_STATUS_ASSIGNED'
export const SET_ASSIGNED_SELECT = 'SET_ASSIGNED_SELECT'

//Local storage
export const LOCAL_ASSIGNED_SELECTE = 'LOCAL_ASSIGNED_SELECTE'


// export const ADD_CATEGORY = 'ADD_CATEGORY'
